import type { NodeType } from "@velizhanin-dev/bot-scenario"
import type { ComponentType } from "react"
import { ButtonsEditor } from "./buttons-editor"
import type { Config, EditorProps } from "./editor-props"
import { CheckSubscriptionEditor } from "./editors/check-subscription-editor"
import { ConditionEditor } from "./editors/condition-editor"
import { GotoEditor } from "./editors/goto-editor"
import { HttpRequestEditor } from "./editors/http-request-editor"
import { MessageEditor } from "./editors/message-editor"
import { NotifyEditor } from "./editors/notify-editor"
import { QuestionEditor } from "./editors/question-editor"
import { RandomEditor } from "./editors/random-editor"
import { SetVariableEditor } from "./editors/set-variable-editor"
import { StartEditor } from "./editors/start-editor"
import { TagEditor } from "./editors/tag-editor"
import { WaitEditor } from "./editors/wait-editor"
import { InvoiceEditor } from "./invoice-editor"

export const NODE_EDITORS: Record<NodeType, ComponentType<EditorProps>> = {
	start: StartEditor,
	message: MessageEditor,
	buttons: ButtonsEditor,
	question: QuestionEditor,
	set_variable: SetVariableEditor,
	wait: WaitEditor,
	goto: GotoEditor,
	condition: ConditionEditor,
	notify: NotifyEditor,
	http_request: HttpRequestEditor,
	check_subscription: CheckSubscriptionEditor,
	random: RandomEditor,
	invoice: InvoiceEditor,
	tag: TagEditor,
}

export type { Config }
